module.exports = __webpack_public_path__ + "static/media/Karthik-compressed.bd24632e.webp";